export default __webpack_public_path__ + "static/media/30.3e3b513b.svg";